import React from 'react';
import { EditableSchemaMetadata, EntityType, GlobalTags, SchemaField } from '../../../../../../../types.generated';
import TagTermDomainGroup from '../../../../../../shared/tags/TagTermGroup';
import { pathMatchesNewPath } from '../../../../../dataset/profile/schema/utils/utils';
import { useAccessibility } from '../../../../../../../AccessibilityHandler';
import { useMutationUrn, useRefetch } from '../../../../EntityContext';
import { useSchemaRefetch } from '../SchemaContext';

export default function useTagsAndTermsRenderer(
    editableSchemaMetadata: EditableSchemaMetadata | null | undefined,
    tagHoveredIndex: string | undefined,
    setTagHoveredIndex: (index: string | undefined) => void,
    options: { showTags: boolean; showTerms: boolean; showDomains: boolean },
    filterText: string,
    readOnly?: boolean,
    addTagDisabledTooltip?: string,
    addTermDisabledTooltip?: string,
    addDomainDisabledTooltip?: string,
) {
    const urn = useMutationUrn();
    const refetch = useRefetch();
    const schemaRefetch = useSchemaRefetch();
    const isAccessibilityEnabled: boolean = useAccessibility();

    const refresh: any = () => {
        refetch?.();
        schemaRefetch?.();
    };

    const tagAndTermRender = (tags: GlobalTags, record: SchemaField) => {
        const relevantEditableFieldInfo = editableSchemaMetadata?.editableSchemaFieldInfo.find(
            (candidateEditableFieldInfo) => pathMatchesNewPath(candidateEditableFieldInfo.fieldPath, record.fieldPath),
        );

        return (
            <div data-testid={`schema-field-${record.fieldPath}-${options.showTags ? 'tags' : 'terms'}`}>
                <TagTermDomainGroup
                    uneditableTags={options.showTags ? tags : null}
                    editableTags={options.showTags ? relevantEditableFieldInfo?.globalTags : null}
                    uneditableGlossaryTerms={options.showTerms ? record.glossaryTerms : null}
                    editableGlossaryTerms={options.showTerms ? relevantEditableFieldInfo?.glossaryTerms : null}
                    editableDomain={options.showDomains ? relevantEditableFieldInfo?.domain : null}
                    canRemove
                    readOnly={readOnly}
                    addTagDisabledTooltip={addTagDisabledTooltip}
                    addTermDisabledTooltip={addTermDisabledTooltip}
                    addDomainDisabledTooltip={addDomainDisabledTooltip}
                    buttonProps={{ size: 'small' }}
                    canAddTag={(tagHoveredIndex === record.fieldPath || isAccessibilityEnabled) && options.showTags}
                    canAddTerm={(tagHoveredIndex === record.fieldPath || isAccessibilityEnabled) && options.showTerms}
                    canAddDomain={
                        (tagHoveredIndex === record.fieldPath || isAccessibilityEnabled) && options.showDomains
                    }
                    onOpenModal={() => setTagHoveredIndex(undefined)}
                    entityUrn={urn}
                    entityType={EntityType.Dataset}
                    entitySubresource={record.fieldPath}
                    highlightText={filterText}
                    refetch={refresh}
                />
            </div>
        );
    };
    return tagAndTermRender;
}
